<template>
  <div class="open-pay">
    <!--标题栏-->
    <app-header title="确认开通" @goback="goBack"></app-header>
    <div class="pay-head">
      <div class="pay-title-text">需支付</div>
      <div class="pay-title-num">{{`¥${totalPrice}`}}</div>
      <div class="pay-money-box">
        <div>
          <div class="money-title">优惠金额</div>
          <div class="money-num">{{ discounts }}</div>
        </div>
        <div>
          <div class="money-title">支付金额</div>
          <div class="money-num">{{ totalPrice - discounts }}</div>
        </div>
      </div>
    </div>
    <div class="pay-content">
      <ul class="pay-list">
        <li v-for="(item,index) in payListWithPrice" :key="index">
          <div>{{ item.productName }}</div>
          <div>{{ item.num }}</div>
          <div>{{ item.price | rmb }}</div>
        </li>
      </ul>
      <div class="pay-total">{{`共计：¥${totalPrice}`}}</div>
    </div>

    <Button class="submit-btn" @click="pay">确认支付</Button>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import apis from 'api/index';
import { mapMutations, mapGetters, mapState } from 'vuex';
import { duration } from 'moment';
import calcPrice, { sumBy } from 'common/js/price-calculator';

export default {
  mixins: [commonMixin],
  filters: {
    rmb(value) {
      if (!value) return ''
      return `￥${value}`;
    }
  },
  data() {
    return {
      discounts: 0
    }
  },
  computed: {
    payListWithPrice() {
      return this.payList.map((pay) => Object.assign({}, pay, {
        price: calcPrice(pay),
      }));
    },
    totalPrice() {
      return sumBy((pay) => pay.price * pay.num, this.payListWithPrice).toFixed(2);
    },
    ...mapState(['payList'])
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async pay() {
      try {
        let params = {
          ids: this.payList.map(item => item.id),
          totalPrice: this.totalPrice
        };
        const res = await apis.renewOrder(JSON.stringify(params));
        this.showDialog('支付成功','alert' , () => {
          this.setPayList([]);
          this.$router.go(-1);
        });
      } catch(err) {
        this.showToast(err.message);
        console.error(err);
      }
    },
    ...mapMutations(['setPayList'])
  }
}
</script>

<style lang="scss" scoped  src="./open.scss"></style>

